define(function(require) {
    const IpsModel = require('civicsBase/ipsModel');
    const ViewManager = require('civicsUtils/view_manager');

    return IpsModel.extend({
        url: function() {
            if(ViewManager.versionRange('8.7.0.2002', '8.8') || ViewManager.versionRange('8.8.0.2003'))
                return '/delegate/civics-api/api/portal/users/forgotpassword/exist';
            else
                return '/delegate/civics-api/api/portal/users/exist';
      }
  });
});
